module.exports = __webpack_public_path__ + "static/media/icon-linkedin.c40e5ce6.svg";